import angular from 'angular';
import moment from 'moment';
import {Component, Module} from './../decorators';

import datePickerTpl from './blnd.datepicker.tpl.html';

@Module({
    name: "app.directives.datepicker",
})
@Component({
    selector: 'blnd-datepicker',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: datePickerTpl,
})
export default class C {

    constructor($element) {
        "ngInject";
        this.$element = $element;
        this.opened = false;
        this.mode = this.mode || 'view';
        this.options = angular.extend({
            startingDay: 1,
        }, {});

        if (this.ngModel !== null && angular.isDefined(this.ngModel) && !angular.isDate(this.ngModel)) {
            this.ngModel = new Date(this.ngModel);
        }
    }

    open () {
        this.opened = true;
    }

    $onDestroy () {
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/blnd.datepicker.js